import { render, staticRenderFns } from "./branchReports.vue?vue&type=template&id=c1910c5e&scoped=true&"
import script from "./branchReports.vue?vue&type=script&lang=js&"
export * from "./branchReports.vue?vue&type=script&lang=js&"
import style0 from "./branchReports.vue?vue&type=style&index=0&id=c1910c5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1910c5e",
  null
  
)

export default component.exports